import { z } from 'zod';
import { DecimalString } from './common.js';

/** POST /api/level-upgrade/rp-ap-orb/execute — RP→AP→ORB then promote (§6 捐币晋级) */
export const RpApOrbLevelUpSchema = z.object({
  target_level: z.string().min(1).max(8),
  transaction_password: z.string().min(1).max(128),
  security_answer: z.string().min(1).max(256),
  memo: z.string().max(500).optional(),
  idempotency_key: z.string().max(64).optional(),
});

export type RpApOrbLevelUpRequest = z.infer<typeof RpApOrbLevelUpSchema>;

export const RpApOrbLevelUpPreviewQuerySchema = z.object({
  target_level: z.string().min(1).max(8),
});

export type RpApOrbLevelUpPreviewQuery = z.infer<typeof RpApOrbLevelUpPreviewQuerySchema>;
